import { render } from "./RecipeDetail.vue?vue&type=template&id=542ae4e2&scoped=true"
import script from "./RecipeDetail.vue?vue&type=script&lang=js"
export * from "./RecipeDetail.vue?vue&type=script&lang=js"

import "./RecipeDetail.vue?vue&type=style&index=0&id=542ae4e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542ae4e2"]])

export default __exports__